import { RouteConfig } from 'vue-router';

import { ModuleName } from '@/enums/moduleName.enum';
import store from '@/store/store';
import { documentIndexFilters } from '@/utils/document';
import { getProfileId } from '@/utils/profile';

export const myDocumentsRoute: RouteConfig = {
  path: 'mydocuments',
  name: 'myDocuments',
  component: () => import(/* webpackChunkName: "MyDocuments" */ '@/views/mainRoute/document/List.vue'),
  meta: {
    breadcrumb: { title: 'Moje wnioski' },
    menu: {
      title: 'Moje wnioski',
      icon: 'fa-home',
      permissions: ['DOCUMENT.LIST'],
      entityType: 'profile',
      entityId: getProfileId,
      query: { order: 'procedure.name' }
    }
  },
  beforeEnter: (to, from, next) => {
    const filters = documentIndexFilters(to, { withProfileId: true, disallowHidden: true });
    store.commit('status/saveList', []);
    store
      .dispatch('documentIndex/list', filters)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: 'Wystąpił błąd podczas ładowania listy wniosków.' }));
  }
};
